import type { DispatchHelpSession } from '@numeo/types'

/**
 * The one-line "who is this" label for a session, shared by the list and the thread header so the two
 * can never disagree about the same session.
 *
 * Order is deliberate. `senderEmail` stays first because it is the mailbox this conversation actually
 * sends from — the most useful thing to see when it exists. It is blank on a large share of sessions
 * (AI Dispatch chat runs before any mailbox is connected), which is the whole reason the rest of the
 * chain exists: the account the driver signed up with, then their number.
 *
 * `ownerEmail` is already placeholder-free server-side — a phone-only account carries a synthetic
 * `@phone.numeo.invalid` address that must never be rendered, so it is stripped in `owner-contact.ts`
 * and arrives as ''. Nothing here needs to know about that scheme.
 *
 * "Mobile user" survives as the last resort: an account can genuinely have no mailbox, no real email
 * and no number.
 */
export function sessionOwnerLabel(session: Pick<DispatchHelpSession, 'senderEmail' | 'ownerEmail' | 'ownerPhone'>): string {
    return session.senderEmail?.trim() || session.ownerEmail?.trim() || session.ownerPhone?.trim() || 'Mobile user'
}
